import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "input", "code", "submit"]

  disconnect() {
    this.unlockScroll()
  }

  open() {
    document.documentElement.style.overflow = "hidden"
    this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  // Runs on the dialog's own close event, so Esc clears the form and frees the page like Cancelar does.
  reset() {
    this.unlockScroll()
    this.inputTarget.value = ""
    if (this.hasCodeTarget) this.codeTarget.value = ""
    this.check()
  }

  check() {
    const typed = this.inputTarget.value.trim().toUpperCase() === "APAGAR"
    const proved = !this.hasCodeTarget || this.codeTarget.value.trim().length === this.codeTarget.maxLength
    this.submitTarget.disabled = !(typed && proved)
  }

  unlockScroll() {
    document.documentElement.style.removeProperty("overflow")
  }
}
